import { Button, Stack, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as React from 'react';
import { dateformat } from '../../../helpers';
import { validFielddHelper } from '../../../helpers/ValidFieldsHelper';

export const FechaField = ({
  label,
  value,
  onChange,
  helperText,
  error,
  views,
  openTo,
  botonCurrentDate = true,
  disabled = false,
  prevent = false,
}) => (
  <LocalizationProvider adapterLocale={'es'} dateAdapter={AdapterDayjs}>
    <Stack direction="row" alignItems="center">
      <DatePicker
        label={label ?? 'Fecha'}
        value={value ?? dateformat(null, {})}
        openTo={openTo ?? 'day'}
        onChange={onChange}
        disabled={disabled}
        views={views ?? ['day']}
        renderInput={(params) => (
          <TextField
            helperText={helperText ?? error ? validFielddHelper(1) : null}
            fullWidth
            size="small"
            type="date"
            required
            onKeyDown={(e) => {
              if (prevent) e.preventDefault();
            }}
            {...params}
            error={error}
          />
        )}
      />
      {botonCurrentDate && (
        <Button size="small" onClick={() => onChange(Date.now())}>
          Hoy
        </Button>
      )}
    </Stack>
  </LocalizationProvider>
);
